import styled, {keyframes} from "styled-components";
import {PRIMARY_COLOR, PRIMARY_COLOR_ACTIVE, PRIMARY_COLOR_HOVER} from "../../const/color";

const PreloaderBodyKeyframes = keyframes`
  0 % {transform: rotate(0deg);}
  100% {transform: rotate(360deg);}
`;

export const PreloaderBody = styled.div `
  width: 70px;
  height: 70px;
  position: relative;
  backface-visibility: hidden;
  
  div{
    position: absolute;
    width: 100%;
    height: 100%;
    border: 5px solid ${PRIMARY_COLOR_ACTIVE};
    border-top-color: transparent;
    border-radius: 50%;
    box-sizing: content-box;
    animation: ${PreloaderBodyKeyframes} 1s linear infinite;
  }

`

export const PreloaderWrap = styled.div`
  width: 100%;
  height: 100%;
  left:0;
  top:0;
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 999;
  background: rgba(217, 217, 217, 0.25);
`